import { render, staticRenderFns } from "./fzrz.vue?vue&type=template&id=4618b41f&scoped=true&"
import script from "./fzrz.vue?vue&type=script&lang=js&"
export * from "./fzrz.vue?vue&type=script&lang=js&"
import style0 from "./fzrz.vue?vue&type=style&index=0&id=4618b41f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4618b41f",
  null
  
)

export default component.exports